
import React from 'react';
import {
    Grid,
    Typography,
} from "@mui/material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import "./styles.css";

const AddressDetails = () => {
    return (
        <Grid className="category" style={{height:'120px'}}>
            <Grid display='flex' flexDirection='column' style ={{margin: '2%', paddingTop:'10px'}}>
                <Typography style={{ color: '#008EA1', fontSize:'15px' }}>Address Details</Typography>
            
            <Grid display='flex' flexDirection='row' style ={{margin: '2%'}}>
            <Grid display='flex' flexDirection='row' marginLeft='-2%'>
                <Typography style={{ color: '#008EA1', fontSize:'15px', whiteSpace:'nowrap'}}>Property Type </Typography>
                <Typography style={{ color: '#000000', fontSize:'15px', marginLeft:'12px'}}> Apartment</Typography> 
                </Grid>
                <Grid display='flex' flexDirection='row' marginLeft='25%'>
                <Typography style={{ color: '#008EA1', fontSize:'15px'}}>Location/Address  &nbsp; </Typography>
                <Typography style={{ color: '#000000', fontSize:'15px', marginLeft:'10px'}}># 101, ABC mansion, ABC Street, Place name, Johannesburg <LocationOnIcon style={{color:'#0D5C75', height:'14px'}}/></Typography> 
                </Grid>
              
            </Grid>
            </Grid>
        </Grid>
    );

};

export default AddressDetails;